module.exports = {
  login:'Entrar',
  taption: 'Taption',
  ways_to_use_taption:'Formas de usar o Taption',
  faq:'FAQ',
  pricing:'Preços',
  language:'Idioma',
  product:'Produtos'
}
